import React, {useEffect} from 'react';
import styles from './Demo.module.css'
import LayoutContentWrapper from "../../components/Layout/LayoutContentWrapper/LayoutContentWrapper";
import ContentHeader from "../../components/Layout/Content/ContentHeader/ContentHeader";
import {UIText} from "../../enums/UIText/UIText";
import {useAppSelector} from "../../hooks/redux";
import {getLanguage} from "../../store/selectors/appSelector";
import {UXDemo} from "../../enums/UXText/UXDemo";
import {EnumPages} from "../../enums/EnumPages";
import {getIsAuth, getIsCompletelyFilledDataUser} from "../../store/selectors/authSelector";
import DemoSuccess from "./DemoSuccess/DemoSuccess";
import DemoDenied from "./DemoDenied/DemoDenied";
import {getTextByLanguage} from "../../enums/utils/getTextByLanguage";
import {EnumLanguage} from "../../enums/EnumLanguage";

const Demo = () => {


    const language = useAppSelector(getLanguage)
    const title = getTextByLanguage(UIText.nav.demo, language)
    const description = getTextByLanguage(UXDemo.description, language)


    const isAuth = useAppSelector(getIsAuth)
    const isCompletelyFilledDataUser = useAppSelector(getIsCompletelyFilledDataUser)

    const isDemoSuccess = isAuth && isCompletelyFilledDataUser

    useEffect(() => {
        document.title = `${UIText.nav.demo[language]} - ${UIText.mis[EnumLanguage.ru]}`
    }, [language])


    return (
        <div className={styles.wrapper}>
            <LayoutContentWrapper>
                <ContentHeader title={title} description={description} editable={true} pageName={EnumPages.demo}/>
            </LayoutContentWrapper>

            {isDemoSuccess ? <DemoSuccess/> :
                <DemoDenied isAuth={isAuth} isCompletelyFilledDataUser={isCompletelyFilledDataUser}/>}
        </div>

    );
};

export default Demo;